export default {"src":"/_next/static/media/_pro_license_filled.3a3aba7c.svg","height":24,"width":24};